export const toJSON = value => {
  return JSON.stringify(value, null, 2)
}



// WEBPACK FOOTER //
// ./src/filters/TextFilters.js